import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MessageBoxResult, MessageBoxIcon, MessageBoxButtons, MessageBoxInjectData } from '../messagebox.model';

@Component({
    selector: 'app-messagedialog',
    templateUrl: './messagedialog.component.html'
})
export class MessageDialogComponent {
    title: string;
    message: string;
    information: string;
    informationLine2: string;
    icon: MessageBoxIcon;
    buttons: MessageBoxButtons;

    textForYes: string;
    textForNo: string;
    private resultForYes: MessageBoxResult;
    private resultForNo: MessageBoxResult;

    constructor(public dialogRef: MatDialogRef<MessageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: MessageBoxInjectData) {
        this.title = data.title;
        this.message = data.message;
        this.information = data.information;
        this.informationLine2 = data.informationLine2;
        this.icon = data.icon;
        this.buttons = data.buttons;
        this.dialogRef.disableClose = true;

        this.initButtonTextAndResult(this.buttons, data.textForYes, data.textForNo);
    }

    initButtonTextAndResult(buttons: MessageBoxButtons, textForYes?: string, textForNo?: string) {
        this.textForYes = textForYes;
        this.textForNo = textForNo;

        switch (buttons) {
            case MessageBoxButtons.Ok:
                this.textForYes ||= 'Ok';
                this.resultForYes = MessageBoxResult.Ok;
                break;
            case MessageBoxButtons.Close:
                this.textForYes ||= 'Close';
                this.resultForYes = MessageBoxResult.Ok;
                break;
            case MessageBoxButtons.OkCancel:
                this.textForYes ||= 'Ok';
                this.textForNo ||= 'Cancel';
                this.resultForYes = MessageBoxResult.Ok;
                this.resultForNo = MessageBoxResult.Cancel;
                break;
            case MessageBoxButtons.YesNo:
                this.textForYes ||= 'Yes';
                this.textForNo ||= 'No';
                this.resultForYes = MessageBoxResult.Yes;
                this.resultForNo = MessageBoxResult.No;
                break;
            case MessageBoxButtons.RemoveCancel:
                this.textForYes ||= 'Remove';
                this.textForNo ||= 'Cancel';
                this.resultForYes = MessageBoxResult.Yes;
                this.resultForNo = MessageBoxResult.Cancel;
                break;
            case MessageBoxButtons.AcceptReject:
                this.textForYes ||= 'Accept';
                this.textForNo ||= 'Reject';
                this.resultForYes = MessageBoxResult.Accept;
                this.resultForNo = MessageBoxResult.Reject;
                break;
            default:
                break;
        }
    }

    clickYes() {
        this.dialogRef.close(this.resultForYes);
    }

    clickNo() {
        this.dialogRef.close(this.resultForNo);
    }
}
